import React from "react";
import { ChevronDown } from "lucide-react";

function TourPackageSelector({ tourPackage, duration, onPackageChange, onDurationChange, durations, t }) {
  return (
    <>
      <div className="relative bg-white">
        <select
          value={tourPackage}
          onChange={(e) => onPackageChange(e.target.value)}
          className="w-full bg-white text-slate-700 text-base md:text-lg rounded-sm px-5 py-4 pr-12 appearance-none focus:outline-none focus:ring-2 focus:ring-[#f5272b] transition-all"
        >
          <option value="" disabled>
            {t("select_tour_package") || "Select Tour Package"}
          </option>
          <option value="6">6 {t("hour") || "Hour"}</option>
          <option value="10">10 {t("hour") || "Hour"}</option>
        </select>
        <ChevronDown
          className="absolute -translate-y-1/2 pointer-events-none right-4 top-1/2 text-slate-400"
          size={24}
        />
      </div>

      <div className="relative bg-white">
        <select
          value={duration}
          onChange={(e) => onDurationChange(e.target.value)}
          className="w-full bg-white text-slate-700 text-base md:text-lg rounded-sm px-5 py-4 pr-12 appearance-none focus:outline-none focus:ring-2 focus:ring-[#f5272b] transition-all"
        >
          <option value="" disabled>
            {t("select_duration") || "Select Duration"}
          </option>
          {durations?.map((item, idx) => (
            <option key={idx} value={item.value}>
              {item.label} {t("days") || "Days"}
            </option>
          ))}
        </select>
        <ChevronDown
          className="absolute -translate-y-1/2 pointer-events-none right-4 top-1/2 text-slate-400"
          size={24}
        />
      </div>
    </>
  );
}

export default TourPackageSelector;
